import React from "react";
import styled, { withTheme } from "styled-components";
import { Box } from "rebass";
import { compose } from "redux";

// const placementCss = positions => {
//   return positions.map(position => `${position}: 0;`).join("\n");
// };
//
const Element = styled.div`
  position: fixed;
  ${({ placement }) => placement};
  top: ${({ top, theme }) => theme.space[top]};
  right: ${({ right, theme }) => theme.space[right]};
  left: ${({ left, theme }) => theme.space[left]};
  bottom: ${({ bottom, theme }) => theme.space[bottom]};
  max-width: 50vw;
  font-weight: 700;
  text-transform: uppercase;
  font-size: ${({ f, theme }) => theme.fontSizes[f]};
  pointer-events: initial;
  padding-top: 1%;
  ${({ other }) => other || ""};
  &:hover {
    cursor: hover;
  }
  & > * {
    display: table-cell;
  }
  &:last-child {
    text-align: right;
  }
  &:first-child {
    margin-left: -0.05em;
  }
`;

const ElementWrapper = props => {
  const { element, layout } = props;
  const [content, extraProps] = element;
  return (
    <Element name="element" {...layout} {...extraProps}>
      <span>{content}</span>
    </Element>
  );
};

const Container = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9;
  pointer-events: none;
`;

export default compose(withTheme)(props => {
  const { elements } = props;
  const { fs, px, pt, pb } = props.theme.frame;
  const layoutProps = [
    {
      f: fs[0],
      top: pt,
      left: px,
      other: "line-height: 1;"
    },
    {
      f: fs[1],
      top: pt,
      right: px,
      other: "line-height: 1; pointer-events: none; text-align: right;"
    },
    {
      f: fs[0],
      bottom: pb,
      left: px,
      other: "line-height: 0.5; padding-top: 4%;"
    },
    {
      bottom: pb,
      right: px,
      f: fs[0],
      other: "line-height: 0.5; padding-top: 4%;"
    }
  ];
  return (
    <Container px={px} pt={pt} pb={pb}>
      {elements.map((element, i) => {
        return (
          <ElementWrapper key={i} element={element} layout={layoutProps[i]} />
        );
      })}
    </Container>
  );
});



// WEBPACK FOOTER //
// ./src/components/overlay.js